import {Image, Text, TouchableOpacity, View} from 'react-native';
import React, {useEffect, useRef, useState} from 'react';
import {useAppSelector} from '../../store/hooks';
import {selectPaperQuestions} from '../../store/xueke';
import {
  WebviewCustomerMemo,
  WebviewCustomerRef,
} from '../../components/WebviewCustomer';
import {AIWebviewURL} from '../../env/webviewUrl';
import {createStyles} from '../../utils/createStyles';
import {downloadXkwUserGenerateRecordFileUrl} from '../../API/mylearn';
import QRCodeModal from '../../components/Url2QRCode';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';
import Toast from 'react-native-toast-message';
import {middlewareType} from '../../utils/webviewJSBridge';

const styles = createStyles({
  paperDetailsBox: {
    flex: 1,
    backgroundColor: '#EAF1FF',
    paddingLeft: '1.65rem',
    paddingRight: '1.15rem',
    paddingVertical: '1.2rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  paperDetailsBoxWeb: {
    backgroundColor: '#fff',
    flex: 1,
    height: '100%',
    borderRadius: '1rem',
    padding: '1.5rem',
  },
  paperDetailsBoxBtn: {
    marginLeft: '1.3rem',
    width: '7.25rem',
    height: '23rem',
    backgroundColor: '#6F63FF',
    borderRadius: '1.75rem',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  paperDetailsBoxBtnItem: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  paperDetailsBoxBtnItemImg: {
    width: '3.25rem',
    height: '3.25rem',
    marginBottom: '0.75rem',
  },
  paperDetailsBoxBtnItemText: {
    color: '#fff',
    fontSize: '1.125rem',
  },
});
const PaperDetails = ({route}: any) => {
  console.log('params', route);
  const questions = useAppSelector<any>(selectPaperQuestions);
  const webviewRef = useRef<WebviewCustomerRef>(null);
  const url = `${AIWebviewURL}/XKW/paperQuestions`;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qrcodeValue, setQrcodeValue] = useState('');
  const [questionRecordId, setQuestionRecordId] = React.useState(0);
  useEffect(() => {
    setQrcodeValue('');
    if (route.params?.id) {
      setQuestionRecordId(route.params?.id);
      return;
    }
    setQuestionRecordId(questions.generateRecordId);
  }, [questions, route]);
  const handleWebViewLoadEnd = () => {
    webviewRef.current?.sendMessage({
      eventName: 'onQuestions',
      data: {
        questions: questions,
        sub_title:
          '学校：________ 姓名：________ 班级：________ 考号：________',
        title: `同步练习测试 ${new Date().toLocaleDateString()}`,
      },
    });
  };
  const handleDownLoadFile = async () => {
    showGlobalLoading({text: '下载中'});
    // 最长 60s 倒计时，超时则取消 每 1 秒请求一次 返回值之后停止倒计时
    let count = 0;
    const timer = setInterval(async () => {
      try {
        const p = {
          generateRecordId: questionRecordId,
        };
        const resaa = await downloadXkwUserGenerateRecordFileUrl(p);
        count++;
        if (count > 60) {
          clearInterval(timer);
        }
        if (resaa.data.status === 2) {
          clearInterval(timer);
          hideGlobalLoading();
          // @ts-ignore
          setQrcodeValue(resaa.data.url);
          setIsModalVisible(true);
        }
        if (resaa.data.status === 3) {
          Toast.show({
            type: 'error',
            text1: '文件下载失败，请稍后重试',
          } as any);
          clearInterval(timer);
          hideGlobalLoading();
        }
        console.log('res', resaa);
      } catch (e) {
        hideGlobalLoading();
        clearInterval(timer);
        console.log(e);
      }
    }, 5000);
  };
  const webEventHandle: middlewareType = (eventName, data, res) => {
    switch (eventName) {
      case 'WebMounted': {
        console.log('WebMounted');
        handleWebViewLoadEnd();
        break;
      }
    }
  };
  return (
    <View style={styles.paperDetailsBox}>
      <View style={styles.paperDetailsBoxWeb}>
        <WebviewCustomerMemo
          ref={webviewRef}
          eventHandle={webEventHandle}
          url={url}
          onLoadEnd={handleWebViewLoadEnd}
        />
      </View>
      <TouchableOpacity
        activeOpacity={1}
        onPress={handleDownLoadFile}
        style={styles.paperDetailsBoxBtn}>
        <View style={styles.paperDetailsBoxBtnItem}>
          <Image
            style={styles.paperDetailsBoxBtnItemImg}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_download.png',
            }}
          />
          <Text style={styles.paperDetailsBoxBtnItemText}>下载试题</Text>
        </View>
      </TouchableOpacity>
      <QRCodeModal
        visible={isModalVisible}
        logoImg={
          'https://media.oss.leziedu.com/webapp/classroom/mylearn/logoC.png'
        }
        value={qrcodeValue}
        onClose={() => {
          setIsModalVisible(false);
        }}
      />
    </View>
  );
};

export default PaperDetails;
